<div>
  @if (showClearAllFilters) {
    <div class="button-container">
      <button (click)="clearAllFilters()"
        class="btn-secondary clear-all-filters-button"
        data-cy="claim-list-clear-all-filters-button">Clear all filters
      </button>
    </div>
  }
  <table class="list-table" data-cy="claim-list">
    <thead>
      <tr class="list-row">
        <th class="list-header-element-button">
          <!-- empty header-->
        </th>
        @if (hasPartnerColumn()) {
          <th
            class="list-header-element"
            data-cy="claim-list-header-partner">
            <div class="label-and-filter">
              <span (click)="sortingBy(ClaimListFilterColumnEnum.PARTNER, partnerArrowUp); arrowToggle()"
                class="sortable"
                data-cy="claim-list-header-arrow-button-partner">
                <app-tooltip message="Partner">
                  <span class="sortable" data-cy="claim-list-header-name-partner">Partner</span>
                </app-tooltip>
              </span>
              <app-tooltip [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.PARTNER"
                [dynamic]="false" class="display-inline-flex"
                message="Sort">
                @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.PARTNER) {
                  <span (click)="sortingBy(ClaimListFilterColumnEnum.PARTNER, partnerArrowUp); arrowToggle()"
                    [ngClass]="{'iwp-icon-gen_arrow_down': !partnerArrowUp, 'iwp-icon-gen_arrow_up': partnerArrowUp}"
                    class="sortable-arrow"
                    data-cy="claim-list-header-arrow-partner">
                  </span>
                }
              </app-tooltip>
              <app-code-filter #partnerFilterComponent
                (filterEvent)="onFilterChange($event)"
                (onOpen)="getPartners()"
                [dataSubject]="partnerOptions"
                [filterName]="ClaimListFilterColumnEnum.PARTNER"
              placeHolder="Search Partner"></app-code-filter>
            </div>
          </th>
        }
        <th class="list-header-element claim-list-medium-column"
          data-cy="claim-list-header-supplying-packing-plant">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.SUPPLYING_PACKING_PLANT, supplyingPackingPlantArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-supplying-packing-plant">
              <app-tooltip message="Supplying Packing Plant">
                <span class="sortable" data-cy="claim-list-header-name-supplying-packing-plant">Supplying Packing Plant</span>
              </app-tooltip>
            </span>
            <app-tooltip
              [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.SUPPLYING_PACKING_PLANT"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.SUPPLYING_PACKING_PLANT) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.SUPPLYING_PACKING_PLANT, supplyingPackingPlantArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !supplyingPackingPlantArrowUp, 'iwp-icon-gen_arrow_up': supplyingPackingPlantArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-supplying-packing-plant">
                </span>
              }
            </app-tooltip>
            <app-code-filter #supplyingPackingPlantFilterComponent
              (filterEvent)="onFilterChange($event)"
              (onOpen)="getSupplyingPackingPlants()"
              [dataSubject]="supplyingPackingPlantOptions"
              [filterName]="ClaimListFilterColumnEnum.SUPPLYING_PACKING_PLANT"
            placeHolder="Search Supplying Packing Plant"></app-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-medium-column"
          data-cy="claim-list-header-number">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.NUMBER, numberArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-number">
              <app-tooltip message="Claim number">
                <span data-cy="claim-list-header-name-claim-number">Claim number</span>
              </app-tooltip>
            </span>
            <app-tooltip [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.NUMBER"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.NUMBER) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.NUMBER, numberArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !numberArrowUp, 'iwp-icon-gen_arrow_up': numberArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-number">
                </span>
              }
            </app-tooltip>
            <app-input-and-code-filter #numberFilterComponent
              (filterEvent)="onFilterChange($event)"
              [filterName]="ClaimListFilterColumnEnum.NUMBER"
              [hasEmptyOption]="false"
            placeHolder="Search number"></app-input-and-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-medium-column"
          data-cy="claim-list-header-reference-number">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.REFERENCE_NUMBER, referenceNumberArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-reference-number">
              <app-tooltip message="Reference number">
                <span data-cy="claim-list-header-name-reference-number">Reference number</span>
              </app-tooltip>
            </span>
            <app-tooltip
              [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.REFERENCE_NUMBER"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.REFERENCE_NUMBER) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.REFERENCE_NUMBER, referenceNumberArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !referenceNumberArrowUp, 'iwp-icon-gen_arrow_up': referenceNumberArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-reference-number">
                </span>
              }
            </app-tooltip>
            <app-input-and-code-filter #referenceNumberFilterComponent
              (filterEvent)="onFilterChange($event)"
              [filterName]="ClaimListFilterColumnEnum.REFERENCE_NUMBER"
              [hasEmptyOption]="true"
            placeHolder="Search Ref. number"></app-input-and-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-status-column"
          data-cy="claim-list-header-status">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.STATUS, statusArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-status">
              <app-tooltip message="Status">
                <span data-cy="claim-list-header-name-status">Status</span>
              </app-tooltip>
            </span>
            <app-tooltip [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.STATUS"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.STATUS) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.STATUS, statusArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !statusArrowUp, 'iwp-icon-gen_arrow_up': statusArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-status">
                </span>
              }
            </app-tooltip>
            <app-code-filter #statusFilterComponent
              (filterEvent)="onFilterChange($event)"
              [dataSubject]="statusOptions"
              (onOpen)="getStatus()"
              [disableInputFilter]="true"
              [filterName]="ClaimListFilterColumnEnum.STATUS"
            [formatWithoutCode]="true"></app-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-medium-column"
          data-cy="claim-list-header-sent-date">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.SENT_DATE, sentDateArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-sent-date">
              <app-tooltip message="Sent date">
                <span data-cy="claim-list-header-name-sent-date">Sent date</span>
              </app-tooltip>
            </span>
            <app-tooltip [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.SENT_DATE"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.SENT_DATE) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.SENT_DATE, sentDateArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !sentDateArrowUp, 'iwp-icon-gen_arrow_up': sentDateArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-sent-date">
                </span>
              }
            </app-tooltip>
            <app-date-filter #sentDateFilterComponent
              (filterEvent)="onFilterChange($event)"
              [dateDisplayedInUtc]="true"
              [filterName]="ClaimListFilterColumnEnum.SENT_DATE"
            class="filter-button"></app-date-filter>
          </div>
        </th>
        <th class="list-header-element"
          data-cy="claim-list-header-material">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.MATERIAL, materialArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-material">
              <app-tooltip message="Material">
                <span data-cy="claim-list-header-name-material">Material</span>
              </app-tooltip>
            </span>
            <app-tooltip [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.MATERIAL"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.MATERIAL) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.MATERIAL, materialArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !materialArrowUp, 'iwp-icon-gen_arrow_up': materialArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-material">
                </span>
              }
            </app-tooltip>
            <app-input-and-code-filter #materialFilterComponent
              (filterEvent)="onFilterChange($event)"
              [filterName]="ClaimListFilterColumnEnum.MATERIAL"
              [hasEmptyOption]="false"
            placeHolder="Search material"></app-input-and-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-small-column"
          data-cy="claim-list-header-model-type">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.MODEL_TYPE, modelTypeArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-model-type">
              <app-tooltip message="Model type">
                <span data-cy="claim-list-header-name-model-type">Model type</span>
              </app-tooltip>
            </span>
            <app-tooltip
              [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.MODEL_TYPE"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.MODEL_TYPE) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.MODEL_TYPE, modelTypeArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !modelTypeArrowUp, 'iwp-icon-gen_arrow_up': modelTypeArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-model-type">
                </span>
              }
            </app-tooltip>
            <app-input-and-code-filter #modelTypeFilterComponent
              (filterEvent)="onFilterChange($event)"
              [filterName]="ClaimListFilterColumnEnum.MODEL_TYPE"
              [hasEmptyOption]="true"
            placeHolder="Search model type"></app-input-and-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-small-column"
          data-cy="claim-list-header-model-code">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.MODEL_CODE, modelCodeArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-model-code">
              <app-tooltip message="Model code">
                <span data-cy="claim-list-header-name-model-code">Model code</span>
              </app-tooltip>
            </span>
            <app-tooltip
              [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.MODEL_CODE"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.MODEL_CODE) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.MODEL_CODE, modelCodeArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !modelCodeArrowUp, 'iwp-icon-gen_arrow_up': modelCodeArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-model-code">
                </span>
              }
            </app-tooltip>
            <app-input-and-code-filter #modelCodeFilterComponent
              (filterEvent)="onFilterChange($event)"
              [filterName]="ClaimListFilterColumnEnum.MODEL_CODE"
              [hasEmptyOption]="true"
            placeHolder="Search model code"></app-input-and-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-small-column"
          data-cy="claim-list-header-lot-number">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.LOT_NUMBER, lotNumberArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-lot-number">
              <app-tooltip message="LOT number">
                <span data-cy="claim-list-header-name-lot-number">LOT no.</span>
              </app-tooltip>
            </span>
            <app-tooltip
              [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.LOT_NUMBER"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.LOT_NUMBER) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.LOT_NUMBER, lotNumberArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !lotNumberArrowUp, 'iwp-icon-gen_arrow_up': lotNumberArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-lot-number">
                </span>
              }
            </app-tooltip>

            <app-input-and-code-filter #lotNumberFilterComponent
              (filterEvent)="onFilterChange($event)"
              [filterName]="ClaimListFilterColumnEnum.LOT_NUMBER"
              [hasEmptyOption]="true"
            placeHolder="Search LOT number"></app-input-and-code-filter>
          </div>
        </th>
        <th class="list-header-element"
          data-cy="claim-list-header-claim-code">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.CLAIM_CODE, claimCodeArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-claim-code">
              <app-tooltip message="Claim code">
                <span data-cy="claim-list-header-name-claim-code">Claim code</span>
              </app-tooltip>
            </span>
            <app-tooltip
              [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.CLAIM_CODE"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.CLAIM_CODE) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.CLAIM_CODE, claimCodeArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !claimCodeArrowUp, 'iwp-icon-gen_arrow_up': claimCodeArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-claim-code">
                </span>
              }
            </app-tooltip>
            <app-code-filter #claimCodeFilterComponent
              (filterEvent)="onFilterChange($event)"
              [dataSubject]="claimCodeOptions"
              (onOpen)="getClaimCodes()"
              [filterName]="ClaimListFilterColumnEnum.CLAIM_CODE"
            placeHolder="Search Claim code"></app-code-filter>
          </div>
        </th>
        <th class="list-header-element claim-list-medium-column"
          data-cy="claim-list-header-changed-on">
          <div class="label-and-filter">
            <span (click)="sortingBy(ClaimListFilterColumnEnum.LAST_CHANGE_DATETIME, changedOnArrowUp); arrowToggle()"
              class="sortable"
              data-cy="claim-list-header-arrow-button-changed-on">
              <app-tooltip message="Changed on">
                <span data-cy="claim-list-header-name-changed-on">Changed on</span>
              </app-tooltip>
            </span>
            <app-tooltip
              [disable]="claimSearchCriteriaService.sortedBy !== ClaimListFilterColumnEnum.LAST_CHANGE_DATETIME"
              [dynamic]="false" class="display-inline-flex"
              message="Sort">
              @if (claimSearchCriteriaService.sortedBy === ClaimListFilterColumnEnum.LAST_CHANGE_DATETIME) {
                <span (click)="sortingBy(ClaimListFilterColumnEnum.LAST_CHANGE_DATETIME, changedOnArrowUp); arrowToggle()"
                  [ngClass]="{'iwp-icon-gen_arrow_down': !changedOnArrowUp, 'iwp-icon-gen_arrow_up': changedOnArrowUp}"
                  class="sortable-arrow"
                  data-cy="claim-list-header-arrow-changed-on">
                </span>
              }
            </app-tooltip>
            <app-date-filter #changedOnFilterComponent
              (filterEvent)="onFilterChange($event)"
              [dateDisplayedInUtc]="true"
              [filterName]="ClaimListFilterColumnEnum.LAST_CHANGE_DATETIME"
            class="filter-button"></app-date-filter>
          </div>
        </th>
        <th class="list-header-element context-menu-header">
          <!-- empty header-->
        </th>
      </tr>
    </thead>
    @if (!isLoading) {
      <tbody>
        @for (item of claimItems; track item) {
          <tr [ngClass]="{'is-open': item.isOpen}" class="list-row" data-cy="claim-list-row">
            <td class="list-element-button" data-cy="claim-list">
                    <div (click)="accordionChangeState(item)" [ngClass]="{'accordion-btn': showQuickView(item.claim),
                         'accordion-btn-disable': !showQuickView(item.claim)}"
                class="arrow-button"
                data-cy="claim-list-row-arrow-button">
                <app-tooltip [disable]="!showQuickView(item.claim)"
                  [dynamic]="false"
                  class="display-inline-flex"
                  message="Claim quick view">
                            <span [ngClass]="{'iwp-icon-gen_arrow_right': !item.isOpen,
                                 'iwp-icon-gen_arrow_down': item.isOpen}">
                  </span>
                </app-tooltip>
              </div>
            </td>
            @if (hasPartnerColumn()) {
              <td
                class="list-element">
                <app-tooltip message="{{item.claim.partner?.code}} {{item.claim.partner?.name}}">
                  <span data-cy="claim-list-element-partner">{{item.claim.partner?.code}} {{item.claim.partner?.name}}</span>
                </app-tooltip>
              </td>
            }
            <td class="list-element">
              <app-tooltip message="{{item.claim.supplyingPackingPlant | prettyPrintReference}}">
                <span data-cy="claim-list-element-supplying-packing-plant">{{item.claim.supplyingPackingPlant | prettyPrintReference}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.number}}">
                <span data-cy="claim-list-element-claim-number">{{item.claim.number | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.referenceNumber}}">
                <span data-cy="claim-list-element-reference-number">{{item.claim.referenceNumber | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [dynamic]="false" class="display-inline-flex"
                message="{{item.claim.status.longDescription}}">
                <span data-cy="claim-list-element-status-dot">
                  <app-status-dot [ngClass]="['status', item.claim.status.code]"></app-status-dot>
                </span>
              </app-tooltip>
              <span class="claim-list-element-status"
              data-cy="claim-list-element-status">{{item.claim.status.description}}</span>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.sentDate | date:'dd-MM-yyyy HH:mm:ss'}}">
                <span data-cy="claim-list-element-sent-date">{{item.claim.sentDate | date:'dd-MM-yyyy HH:mm:ss' | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.material | prettyPrintMaterialNumber}}">
                <span data-cy="claim-list-element-material">{{item.claim.material | prettyPrintMaterialNumber | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.modelType}}">
                <span data-cy="claim-list-element-model-type">{{item.claim.modelType | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.modelCode}}">
                <span data-cy="claim-list-element-model-code">{{item.claim.modelCode | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.lotNumber}}">
                <span data-cy="claim-list-element-lot-number">{{item.claim.lotNumber | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.claimCode | prettyPrintReference | undefinedValue}}">
                <span data-cy="claim-list-element-claim-code">{{item.claim.claimCode | prettyPrintReference | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.claim.lastChangeDatetime | date:'dd-MM-yyyy HH:mm:ss'}}">
                <span data-cy="claim-list-element-change-date">{{item.claim.lastChangeDatetime | date:'dd-MM-yyyy HH:mm:ss'}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <span class="list-element-menu" data-cy="claim-list-element-menu" ngbDropdown>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Claim actions">
                  <span class="iwp-icon-gen_kontextmenu" ngbDropdownToggle></span>
                </app-tooltip>
                <div ngbDropdownMenu>
                  @if (userService.hasPermissions([Permission.PARTNER_CLAIM_SEND])) {
                    <div (click)="item.contextMenuOptions.canSubmit && contextMenuSend(item.claim)"
                      [class.disable]="!item.contextMenuOptions.canSubmit"
                      data-cy="claim-list-element-menu-send"
                    ngbDropdownItem>Send</div>
                  }
                  @if (userService.hasPermissions([Permission.PARTNER_CLAIM_EDIT])) {
                    <div (click)="item.contextMenuOptions.canEdit && contextMenuEdit(item.claim.number)"
                      [class.disable]="!item.contextMenuOptions.canEdit"
                      data-cy="claim-list-element-menu-edit"
                    ngbDropdownItem>Edit</div>
                  }
                  @if (userService.hasPermissions([Permission.PARTNER_CLAIM_VIEW, Permission.ADMIN_CLAIM_VIEW])) {
                    <div
                      [class.disable]="false"
                      [routerLink]="[item.claim.number]"
                      data-cy="claim-list-element-menu-view-detail"
                    ngbDropdownItem>View detail</div>
                  }
                  <div class="separator"></div>
                  @if (userService.hasPermissions([Permission.PARTNER_CLAIM_DELETE])) {
                    <div (click)="item.contextMenuOptions.canDelete && deleteClaim(item.claim)"
                      [class.disable]="!item.contextMenuOptions.canDelete"
                      data-cy="claim-list-element-menu-delete"
                    ngbDropdownItem>Delete</div>
                  }
                </div>
              </span>
            </td>
          </tr>
          <tr>
            <td [colSpan]="getClaimMaterialPositionTableColspan()">
              <div [ngbCollapse]="!item.isOpen"
                class="accordion-positions-list"
                data-cy="claim-list-position-list">
                <app-material-position-table
                  [claimNumber]="item.claim.number"
                  [enableComponentLoading]="true"
                  [material]="item.claim.material"
                  [partnerCode]="item.claim.partner.code"
                  [maxElements]="10"
                  [positions]="item.positions"
                  [showButtonAdd]="false"
                  [showContextMenu]="false"
                  [showMaterialTitle]="false"
                  [showSectionTitle]="true"
                [supplyingPackingPlantCode]="item.claim.material.supplyingPackingPlantCode"></app-material-position-table>
              </div>
            </td>
          </tr>
        }
      </tbody>
    }
  </table>

  @if (tableIsLoading) {
    <div class="spinner-container" data-cy="loading-spinner-overlay">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }

  @if (claimItems?.length == 0) {
    <div class="list-empty">
      <div class="list-empty-icon"><span class="iwp-icon-iwp_task"></span></div>
      <div class="list-empty-description">The claim list is empty</div>
    </div>
  }
</div>

@if (claimSearchCriteriaService.totalResults > claimSearchCriteriaService.pageSize) {
  <app-pagination (pageNumber)="changePage($event)"
    [collectionSize]="claimSearchCriteriaService.totalResults"
    [pageSize]="claimSearchCriteriaService.pageSize"
    [page]="claimSearchCriteriaService.pageNumber"
    class="list-pagination"
    data-cy="claim-list-pagination">
  </app-pagination>
}
